import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ForgotPasswordService } from './forgot-password.service';
import { BaseUtils } from '../core/baseUtils.service';
import { appConfig } from '../../app.config';

@Component({
  selector: 'ba-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['../../login/login.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  constructor(private forgotPasswordService: ForgotPasswordService,
    private baseUtils: BaseUtils) { }

  userName: string;
  captcha: boolean = false;
  siteKey: string = '';
  secretKey: string = '';
  noCaptchaError: string = '';
  @ViewChild('forgotPasswordForm', { static: true }) forgotPasswordForm: any;
  @Output() resetModalState = new EventEmitter();

  ngOnInit(): void {
    this.siteKey = appConfig.captchchaSiteKey;
    this.secretKey = appConfig.captchaSecretKey;
  }

  resetPassword(formData: NgForm) {
    if (!this.captcha) {
      this.noCaptchaError = 'Captcha verification is required';
      return;
    }
    this.baseUtils.loading_spinner(true);
    this.forgotPasswordService.sendUserName(formData.value.username).subscribe((res) => {
      this.baseUtils.loading_spinner(false);
      if (res?.status === 200) {
        this.baseUtils.toasterMessageAction('success', res.message);
        this.resetModalState.emit(false);
      }
    });
    this.forgotPasswordForm.submitted = false;
  }

  handleSuccess(event) {
    this.noCaptchaError = '';
  }

}
